<template>
  <div>
    <div>
      <!-- Home page content -->
      <main role="main">
        <div class="text-center py-md-5 px-md-4 py-3">
          <div class="container">
            <h1 class="text-center text-pg-blue mb-3 brand-fontcolor">
              {{ $t('Home.BannerTitle') }}
            </h1>
            <p class="page-subheader" v-html="$t('Home.BannerDesc')"></p>
          </div>
        </div>
        <div class="text-center readytosubmit mb-md-5 mb-3">
          <div class="container">          
          <div class="row d-flex justify-content-between align-items-center">
            <div class="col-sm-12 text-sm-center">
              <h2 class="" v-html="$t('Home.ReadytoSubmitTitle')"></h2>
              <p class="mt-3" v-html="$t('Home.ReadytoSubmitDesc')"></p>

              <div class="col-sm-12">
                <div class="mb-4">
                  <router-link to="/Upload" class="btn btn-link">
                    {{ $t('Home.GetStartedBtn') }}</router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 mb-3">
              <small v-html="$t('Home.ParticipatingProductLink')"></small>
            </div>
            <div class="col-sm-12 mb-3">
              <small v-html="$t('Home.ParticipatingBookLink')"></small>
            </div>
            <div class="col-sm-12">
               <small v-html="$t('Home.HavingTroubleLink')"></small>
            </div>
          </div>
          </div>
        </div>
        <div id="htp-section" class="py-md-5 py-3">
          <div class="container">
           <h2 class="text-center mb-md-5 mb-3">{{ $t('Home.HowToParticipateTitle') }}</h2>
            <div class="row text-center d-flex justify-content-center">
              <div class="col-md-6 col-lg-4 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.ShopImg')" alt="Shop" class="img-fluid mb-3" />
                  <h4 v-html="$t('Home.ShopTitle')"></h4>
                  <p>
                    <span v-html="$t('Home.ShopDetail')"></span>
                  </p>
                </div>
              </div>

              <div class="col-md-6 col-lg-4 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.SnapImg')" alt="Snap" class="img-fluid mb-3" />
                  <h4 v-html="$t('Home.SnapTitle')"></h4>
                  <p>
                    <span v-html="$t('Home.SnapDetail')"></span>
                  </p>
                </div>
              </div>
              <div class="col-md-6 col-lg-4 home-card-bg">
                <div class="home-card">
                  <img :src="$t('Home.SendImg')" alt="Send" class="img-fluid mb-3" />
                  <h4 v-html="$t('Home.SendTitle')"></h4>
                  <p>
                    <span v-html="$t('Home.SendDetail')"></span>
                  </p>
                </div>
              </div>
              <!-- <div class="col-md-6 col-lg-4 home-card-bg">
            <div class="home-card">
              <img
                 :src="$t('Home.RegisterImg')"
                alt="Register"
                class="img-fluid mb-3"
              />
              <h4>{{ $t('Home.RegisterTitle') }}</h4>
              <p>
                <small v-html="$t('Home.RegisterDetail')"></small>
              </p>
            </div>
          </div> -->
            </div>
          </div>
        </div>
        <div class="text-center py-md-5 py-3" id="seo-section">
          <div class="container">
            <h3 v-html="$t('Home.seoHeadline')"></h3>
            <p v-html="$t('Home.seoDescription')"></p>
          </div>
         </div>
      </main>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    startDate: {
      type: Date,
      required: true,
    },
    endDate: {
      type: Date,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
}
</style>

<style scoped>
/* .home-card-bg {
  position: relative;
}
.home-card {
  box-shadow: 0 15px 25px rgba(129, 124, 124, 0.2);
  height: 380px;
  border-radius: 19px;
  backdrop-filter: blur(14px);
  background-color: rgb(255 255 255 / 20%);
  padding: 15px;
  text-align: left;
  line-height: 23px;
  font-size: 1.2rem;
}
.home-card-bg:before {
  content: '';
  position: absolute;
  height: 70px;
  width: 70px;
  top: -9px;
  left: 5px;
  background-color: #bf233a;
  border-radius: 18px;
}
.home-card img {
  height: 70px;
} */
/* .readytosubmit {
  background: #bf233a2b;
  border: 1px solid #bf233a;
  border-radius: 10px;
  padding: 20px 30px;
} */
@media screen and (max-width: 575px) {
  .home-card {
    height: auto;
    margin-bottom: 40px;
  }
}
</style>
